<template>
  <EventTileBase
    :event="event"
    :showEdit="showEdit"
    :canEdit="canEditEvent"
    :showMenu="showMenu"
    :showPinnedActions="showPinnedActions"
    :showLeagueLogo="showLeagueLogo"
    :showTeamLogos="showTeamLogos"
    @navigate="emit('navigate'); router.push(`/event/${event._id}`)"
    @unpinEvent="emit('unpinEvent', $event)"
    @deleteEvent="emit('deleteEvent', $event)"
    @cancelEvent="emit('cancelEvent', $event)"
    @editEvent="emit('editEvent', $event)"
    @menuOpen="emit('menuOpen')"
    @menuClose="emit('menuClose')"
  >
    <template #detail>
      <div v-if="event.description" class="match-tile-desc">
        {{ event.description }}
      </div>
    </template>
  </EventTileBase>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { useRouter } from 'vue-router'
import type { IEvent } from '@/types'
import EventTileBase from '@/components/EventTiles/EventTileBase.vue'
import { useEventPermissions } from '@/composables/useEventPermissions'

const props = defineProps<{
  event: IEvent
  fullDate?: boolean
  showEdit: boolean
  showMenu?: boolean
  showPinnedActions?: boolean
  showLeagueLogo?: boolean
  showTeamLogos?: boolean
}>()

const router = useRouter()
const emit = defineEmits(['unpinEvent', 'deleteEvent', 'cancelEvent', 'editEvent', 'menuOpen', 'menuClose', 'navigate'])

const { canEditEvent } = useEventPermissions(toRef(props, 'event'), 'event-admin')
</script>

<style lang="scss" scoped>
.match-tile-desc {
  font-size: 0.75rem;
  font-weight: 400;
  color: rgba(var(--v-theme-sheetText), 0.45);
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
